import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Draggable, { DraggableProps } from 'react-draggable';
import { tl } from 'common/services/i18nService';
import { SessionState } from 'common/store/session/reducer';
import * as styles from './ImpersonationBanner.scss';

interface ImpersonationBannerProps {
  onExit: () => void;
}

const DraggableAny = Draggable as React.ComponentType<Partial<DraggableProps>>;

const ImpersonationBanner: React.FC<ImpersonationBannerProps> = ({ onExit }) => {
    const { user, originalUser, impersonationType } = useSelector(
        (state: { session: SessionState }) => state.session
    );

    useEffect(() => {
        let targetDoc = document;
        if (window.top !== window.self) {
            try {
                targetDoc = window.top.document;
            } catch {
                targetDoc = document;
            }
        }

        const body = targetDoc?.body;
        if (body && !body.classList.contains('impersonationActive')) {
            body.classList.add('impersonationActive');
        }

        return () => {
            if (body?.classList?.contains('impersonationActive')) {
                body.classList.remove('impersonationActive');
            }
        };
    }, []);

    if (!originalUser) {
        return null;
    }

    const impersonatedUserName = `${user.firstName} ${user.lastName}`.trim() || user.userName;

    const bannerText = impersonationType === 'VIEW_ONLY'
        ? tl('impersonation.banner.view.text')
        : tl('impersonation.banner.operate.text');

    return (
        <DraggableAny handle={`.${styles.impersonationBanner}`} bounds="body">
            <div className={styles.impersonationBanner}>
                <div className={styles.bannerInfoSection}>
                    <div className={styles.bannerIcon}>
                        <img src={require('./icons/impersonation_icon.svg')} alt="impersonation" />
                    </div>
                    <p className={styles.bannerText}>
                        {bannerText}
                        {' '}
                        <strong>{impersonatedUserName}</strong>
.
                        {' '}
                        {tl('impersonation.banner.text')}
.
                    </p>
                </div>
                <div className={styles.bannerActionSection}>
                    <button type="button" onClick={onExit} className={styles.bannerExitButton}>
                        {tl('impersonation.exit.account')}
                    </button>
                </div>
            </div>
        </DraggableAny>
    );
};

export default ImpersonationBanner;
